var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 9V5.991C9 5.444 9.444 5 9.991 5h.007C10.551 5 11 5.449 11 6.002V9h2.987A1.012 1.012 0 0115 10.013a.987.987 0 01-.987.987H11v3.008a.993.993 0 01-.992.992h-.011A.998.998 0 019 14.003V11H6a1 1 0 01-1-1v-.001c0-.265.105-.519.293-.706A.995.995 0 015.999 9H9zm1 11C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 100-16 8 8 0 000 16z",
    fillRule: "nonzero"
  })));
}
export default SvgPlus3;